var _defs, _g, _g2, _path, _path2, _polygon, _rect, _g3, _ellipse, _ellipse2, _path3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodiiiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.67 147.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #e97124;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.44,47.48C3.52,50.03.42,55.1.42,60.65v48.13c0,2.98,1.68,5.71,4.34,7.06l60.72,30.66c.85.44,1.87.44,2.72,0l69.02-35.69c4.92-2.55,8.01-7.63,8.01-13.17v-48.85c-.01-3.03-1.74-5.79-4.47-7.11l-37.79-18.33-12.48-6.41c-7.34-3.78-16.06-3.74-23.38.09l-16.05,8.41L8.44,47.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.85,147.25c-.53,0-1.07-.13-1.56-.38L4.57,116.21c-2.82-1.42-4.57-4.27-4.57-7.44v-48.13c0-5.72,3.16-10.91,8.24-13.54l42.64-22.05,16.05-8.41c7.43-3.89,16.31-3.93,23.77-.09l12.48,6.41,37.78,18.33c2.85,1.38,4.69,4.32,4.69,7.49v48.85c.01,5.72-3.15,10.91-8.23,13.54l-69.02,35.69c-.49.25-1.02.38-1.56.38ZM8.63,47.86c-4.8,2.48-7.79,7.38-7.79,12.79v48.13c0,2.84,1.58,5.4,4.11,6.68l60.72,30.66c.73.38,1.61.38,2.34,0l69.02-35.69c4.8-2.48,7.79-7.38,7.79-12.79v-48.85c-.01-2.85-1.67-5.49-4.23-6.73l-37.79-18.33-12.49-6.42c-7.21-3.71-15.81-3.68-22.99.09l-16.05,8.41L8.63,47.86Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.59,82.11v24.11c0,1.11.62,2.12,1.6,2.63l19.37,10.01c1.97,1.02,4.33-.41,4.33-2.63v-24.11c0-1.11-.62-2.12-1.6-2.63l-19.37-10.01c-1.97-1.02-4.33.41-4.33,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.92,119.63c-.53,0-1.06-.13-1.56-.38l-19.37-10.01c-1.13-.58-1.83-1.74-1.83-3.01v-24.11c0-1.19.61-2.27,1.63-2.89,1.02-.62,2.26-.66,3.32-.12l19.37,10.01c1.13.58,1.83,1.74,1.83,3.01v24.11c0,1.19-.61,2.27-1.63,2.89-.54.33-1.15.5-1.76.5ZM20.55,79.57c-.46,0-.91.12-1.32.37-.76.46-1.22,1.28-1.22,2.17v24.11c0,.95.53,1.82,1.37,2.26l19.37,10.01c.79.41,1.72.38,2.49-.09.76-.46,1.22-1.28,1.22-2.17v-24.11c0-.95-.53-1.82-1.37-2.26l-19.37-10.01c-.37-.19-.77-.29-1.17-.29Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.01,86.74l54.71-28.29c3.47-1.79,7.6.72,7.6,4.63v35.22c0,2.92-1.63,5.6-4.22,6.94l-54.28,28.07c-3.66,1.89-8.03-.76-8.03-4.89v-34.74c0-2.92,1.63-5.6,4.22-6.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.74,84.49c-1.63,0-3.25-.38-4.73-1.15L7.78,55.94l.38-.76,54.23,27.4c2.72,1.41,5.97,1.41,8.69,0l67.6-34.96.39.75-67.6,34.96c-1.48.77-3.11,1.15-4.73,1.15Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.58 57.86 57.77 57.86 57.77 42.82 48.05 36.02 50.24 32.9 61.58 40.83 61.58 57.86"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.23,
    y: 11.1,
    width: 3.81,
    height: 33.11
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 90.13,
    cy: 6.15,
    r: 5.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.13,12.29c-3.39,0-6.15-2.76-6.15-6.15s2.76-6.15,6.15-6.15,6.15,2.76,6.15,6.15-2.76,6.15-6.15,6.15ZM90.13.85c-2.92,0-5.3,2.38-5.3,5.3s2.38,5.3,5.3,5.3,5.3-2.38,5.3-5.3-2.38-5.3-5.3-5.3Z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 92.53,
    cy: 95.25,
    rx: 6.72,
    ry: 4.15,
    transform: "translate(-34.54 133.82) rotate(-62.71)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 123.1,
    cy: 77.56,
    rx: 6.72,
    ry: 4.15,
    transform: "translate(-2.27 151.41) rotate(-62.71)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.54,104.59l22.82-13.31c.99-.58,2.21.2,2.12,1.34h0c-3.83,15.58-13.11,20.69-17.04,22.01-1.33.45-2.77.66-4.14.36-4.33-.96-6.66-4.36-5.72-7.92h0c.32-1.04,1.02-1.92,1.96-2.47Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 46.25,
    cy: 32.06,
    rx: 5.33,
    ry: 5.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.25,38.21c-3.16,0-5.72-2.76-5.72-6.15s2.57-6.15,5.72-6.15,5.72,2.76,5.72,6.15-2.57,6.15-5.72,6.15ZM46.25,26.76c-2.72,0-4.93,2.38-4.93,5.3s2.21,5.3,4.93,5.3,4.93-2.38,4.93-5.3-2.21-5.3-4.93-5.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodiiiIcon);
export default __webpack_public_path__ + "static/media/codiii-icon.6f537ecb7407941bcbe461e82b83df08.svg";
export { ForwardRef as ReactComponent };